"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate_iptu = exports.mask_iptu = exports.create_iptu = void 0;
var iptu_validate_1 = require("./iptu_validate");
var iptu_mask_1 = require("./iptu_mask");
var utils_1 = require("./utils");
var iptu_create_1 = require("./iptu_create");
exports.create_iptu = function (number, estado, cidade) {
    if (!iptu_create_1.IPTUCREATE[estado] || !iptu_create_1.IPTUCREATE[estado][cidade]) {
        return true;
    }
    number = utils_1.getAllDigits(number);
    return iptu_create_1.IPTUCREATE[estado][cidade](number);
};
exports.mask_iptu = function (number, estado, cidade) {
    if (!iptu_mask_1.IPTUMASKS[estado] || !iptu_mask_1.IPTUMASKS[estado][cidade]) {
        return number;
    }
    return iptu_mask_1.IPTUMASKS[estado][cidade];
};
exports.validate_iptu = function (number, estado, cidade) {
    if (!iptu_validate_1.IPTUVALIDATE[estado] || !iptu_validate_1.IPTUVALIDATE[estado][cidade]) {
        return true;
    }
    number = utils_1.getAllDigits(number);
    return iptu_validate_1.IPTUVALIDATE[estado][cidade](number);
};
